module.exports = __webpack_public_path__ + "static/media/DogBgGfx.eaf6e3ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doghouse/DogBgGfx.png
// module id = 2628
// module chunks = 3